<template>
<div class="flex flex-row flex-nowrap border rounded-md gap-4 p-2">
  <div class="flex flex-col justify-center items-center h-28 w-28 border grow-0 shrink-0 relative">
    <UnLazyImage :src="logo" class="max-h-full max-w-full" @error="setDefaultImage"/>
  </div>
  <div class="basis-full flex flex-col gap-0.5 self-center overflow-hidden">
    <div class="flex mb-1" v-if="!data.is_opened">
      <UBadge color="black" size="xs" variant="solid" :ui="{ rounded: 'rounded-sm' }">Closed</UBadge>
    </div>
    <!-- <div class="flex mb-1" v-else-if="!data.is_deliverable">
      <UBadge color="red" size="xs" variant="solid" :ui="{ rounded: 'rounded-sm' }">Non-deliverable</UBadge>
    </div> -->
    <p class="font-semibold line-clamp-2">{{ data.name }}</p>
    <p class="text-sm line-clamp-1 break-all text-gray-500" v-if="isFandB">{{ availableCategories.join(', ') }}</p>
    <p class="text-sm line-clamp-2 text-gray-500" v-if="!isFandB">{{ formattedAddress }}</p>
    <div class="inline-flex items-center" v-if="isFandB">
      <UIcon name="i-heroicons-map-pin-solid"/>
      <p class="text-sm line-clamp-1">{{ taglineItems.join('|') }}</p>
    </div>
  </div>
</div>
</template>

<script setup>
const runtimeConfig = useRuntimeConfig();
const props = defineProps(['data'])

const isFandB = props.data?.category?.name.toUpperCase() === 'F&B';
const logo = useSecureImage(props.data?.images?.thumbnail || props.data?.images?.gallery[0] || undefined);
const address = props.data?.locations?.address || {};
const { door = '', street = '', city = '' } = address;
const formattedAddress = isFandB ? [door, street, city].filter(Boolean).join(' ') : city;
const taglineItems = [];
const isDistanceInMetres = props.data?.distance <= 1000
const distanceArray = [
  isDistanceInMetres ? Math.ceil(props.data?.distance / 10) * 10 : (props.data?.distance / 1000).toFixed(1),
  isDistanceInMetres ? 'm' : 'km'
]
if (props.data?.distance) { taglineItems.push(`${distanceArray.join('')}`) };
const availableCategories = props.data?.available_categories?.map(k => 
  typeof k === 'object' && k !== null ? k.sub_category : k
).filter(k => typeof k === 'string' && k.toLowerCase() !== 'none') || [];

const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultImage;
}
</script>